import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/logo-white.svg'


const _withScopeId = n => (_pushScopeId("data-v-0fde24f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-placeholder mt-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-placeholder" }, null, -1))
const _hoisted_3 = {
  class: "footer segment-title text-white py-3 py-md-5",
  id: "footer",
  "data-title": "contact us"
}
const _hoisted_4 = { class: "container-lg my-md-5" }
const _hoisted_5 = { class: "row justify-content-center justify-content-lg-between mt-4 mt-lg-0" }
const _hoisted_6 = { class: "col-12 col-md-6 order-0 text-center text-md-start mb-4 mb-lg-0 order-1 order-md-0" }
const _hoisted_7 = { class: "row justify-content-center justify-content-lg-between mt-4 mt-lg-0" }
const _hoisted_8 = { class: "col-12 col-md-6 order-0 text-center text-md-start mb-4 mb-lg-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/#About" }, "About", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/#Solutions" }, "Solutions", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/#Projects" }, "Projects", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/#Partners" }, "Partnerships", -1))
const _hoisted_13 = {
  id: "ContactUs",
  class: "col-12 col-md-6 order-0 text-center text-md-start mb-4 mb-lg-0"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer-address col-12 order-1 order-md-2 order-lg-1 text-center text-md-start mb-4 mb-lg-0 pt-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Office 3 | Rydallviews | 5A Rydall Vale Office Park | 38 Douglas Saunders Drive | La Lucia Ridge | Durban | "),
    /*#__PURE__*/_createElementVNode("b", null, "Kwa-Zulu Natal")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Unit 2 | 25 Merlot Close | JT Ross Park | Plumbago Business Park | Kempton Park | "),
    /*#__PURE__*/_createElementVNode("b", null, "Gauteng")
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-md-4 col-lg-12 order-1 text-center text-md-start my-3 my-md-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img-fluid",
    src: _imports_0,
    alt: "Magneto Renewable Energy logo"
  })
], -1))
const _hoisted_16 = { class: "col-12 col-md-6 order-0 text-center text-md-start mb-4 mb-lg-0 order-0 order-md-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ContactForm = _resolveComponent("ContactForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _createVNode(_component_router_link, {
                    class: "nav-link",
                    to: {name: 'ResidentialHome'}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Residential")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_router_link, { to: {name: 'TermsAndConditions'} }, {
                    default: _withCtx(() => [
                      _createTextVNode("Terms & Conditions")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, { to: {name: 'PrivacyPolicy'} }, {
                    default: _withCtx(() => [
                      _createTextVNode("Privacy Policy")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _hoisted_14,
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_ContactForm, {
                class: "col-12 order-1 order-md-2 order-lg-1 text-center text-md-start mb-2 mb-lg-0 mt-5 mt-md-0",
                onLoading: _cache[0] || (_cache[0] = (x) => _ctx.loading = x)
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}